import createReactComponent from '../createReactComponent';
var ChevronLast = createReactComponent('ChevronLast', [['polyline', {
  points: '7 18 13 12 7 6',
  key: '1minw5'
}], ['path', {
  d: 'M17 6v12',
  key: '1o0aio'
}]]);
export default ChevronLast;